import {APICore} from "./apiCore";
import {AUTH_LIMIT} from "./authLimit";

// Sign-in steps reject with an AuthLimitError when rate limited (see authLimit.ts).
const limited = { [AUTH_LIMIT]: true };

const api = new APICore();

// account
function login(params: { email: string; password: string }) {
    const baseUrl = "/api/auth/login";
    return api.create(`${baseUrl}`, params, limited);
}

function refreshToken(params: { refresh_token: string }) {
    const baseUrl = "/api/auth/refresh-token";
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = "/api/auth/logout";
    return api.create(`${baseUrl}`, {});
}

function forgotPassword(params: { email: string }) {
    const baseUrl = "/api/auth/forgot_password/";
    return api.create(`${baseUrl}`, params);
}

function resetPassword(params: { token: string, password: string, password_confirmation: string }) {
    const baseUrl = "/api/auth/reset-password/verify";
    return api.create(`${baseUrl}`, params, limited);
}

// Self-service: the logged-in admin changes their own password.
function changePassword(params: { oldPassword: string; newPassword1: string; newPassword2: string }) {
    return api.update("/api/auth/change-password", params);
}

// ── MFA ──────────────────────────────────────────────────────────────────────
function mfaVerify(params: { challengeToken: string; code: string }) {
    return api.create("/api/auth/mfa/verify", params, limited);
}
function mfaResend(params: { challengeToken: string }) {
    return api.create("/api/auth/mfa/resend", params, limited);
}
function mfaStatus() {
    return api.get("/api/auth/mfa/status", {});
}
function mfaEnrollStart(params?: { code?: string }) {
    return api.create("/api/auth/mfa/enroll/start", params || {});
}
function mfaEnrollConfirm(params: { challengeToken: string; code: string }) {
    return api.create("/api/auth/mfa/enroll/confirm", params);
}
function mfaDisable(params: { code: string }) {
    return api.create("/api/auth/mfa/disable", params);
}
function mfaRegenerateBackupCodes(params: { code: string }) {
    return api.create("/api/auth/mfa/backup-codes/regenerate", params);
}
// Admin management
function mfaCoverage() {
    return api.get("/api/admin/mfa/coverage", {});
}
function mfaResetUser(userId: number, params: { code: string }) {
    return api.create(`/api/admin/mfa/users/${userId}/reset`, params);
}
function mfaSetTypePolicy(typeId: number, params: { required: boolean }) {
    return api.updatePatch(`/api/admin/mfa/user-types/${typeId}/policy`, params);
}

export {login, refreshToken, logout, forgotPassword, resetPassword, changePassword,
    mfaVerify, mfaResend, mfaStatus, mfaEnrollStart, mfaEnrollConfirm, mfaDisable, mfaRegenerateBackupCodes,
    mfaCoverage, mfaResetUser, mfaSetTypePolicy};
